import React, { useState, useRef } from 'react';
import {
  ContactmeContainer,
  ContactmeH1,
  AboutUsContainer,
  TextContainer,
  StyledContactForm,
  ButtonContainer,
  FeedbackMessage
} from './ContactmeElements';
import emailjs from '@emailjs/browser';
import { Button } from '../ButtonElement';
import { Link as LinkScroll } from 'react-scroll';

const Contactme = () => {
  const form = useRef();
  const [MathQ, setMathQ] = useState('');
  const [Solution] = useState(10);
  const [feedback, setFeedback] = useState({ message: '', type: '' });

  const sendEmail = (e) => {
    e.preventDefault();
    if (Number(MathQ) === Solution) {
      emailjs
        .sendForm(
          process.env.REACT_APP_SERVICE,
          process.env.REACT_APP_TEMPLATE,
          form.current,
          process.env.REACT_APP_KEY
        )
        .then(
          (result) => {
            console.log(result.text);
            setFeedback({ message: 'Nachricht erfolgreich gesendet!', type: 'success' });
            form.current.reset();
            setMathQ('');
          },
          (error) => {
            console.log(error.text);
            setFeedback({ message: 'Fehler beim Senden. Bitte erneut versuchen.', type: 'error' });
          }
        );
    } else {
      setFeedback({ message: 'Falsche Antwort – bitte erneut versuchen.', type: 'error' });
    }
  };

  return (
    <ContactmeContainer id="contact">
      <ContactmeH1>Unverbindlich anfragen</ContactmeH1>
      <AboutUsContainer>
        <TextContainer>
          <p><strong>Software Solution</strong></p>
          <p>Strasshoferstraße 25/1/1</p>
          <p>2620 Wartmannstetten</p>
          <p>Tel: <a href="tel:+436601650720">+43 660 165 0720</a></p>
          <p>Mail: <a href="mailto:info@softwaresolution.at">info@softwaresolution.at</a></p>
        </TextContainer>

        <StyledContactForm>
          <form ref={form} onSubmit={sendEmail}>
            <label htmlFor="name">Name</label>
            <input type="text" name="user_name" id="name" placeholder="Max Mustermann" required />

            <label htmlFor="email">E-Mail</label>
            <input type="email" name="user_email" id="email" placeholder="max@example.com" required />

            <label htmlFor="message">Nachricht</label>
            <textarea name="message" id="message" placeholder="Ihre Nachricht..." required />

            <label htmlFor="captcha">Spam-Schutz: 7 + 3 = ?</label>
            <input
              type="text"
              name="captcha"
              placeholder="Antwort eingeben"
              onChange={(e) => setMathQ(e.target.value)}
              required
            />

            <input type="submit" value="Nachricht senden" />
            {feedback.message && (
              <FeedbackMessage type={feedback.type}>{feedback.message}</FeedbackMessage>
            )}
          </form>
        </StyledContactForm>
      </AboutUsContainer>

      <ButtonContainer>
        <LinkScroll to="home" smooth={true} duration={500}>
          <Button>Zurück zur Startseite</Button>
        </LinkScroll>
      </ButtonContainer>
    </ContactmeContainer>
  );
};

export default Contactme;
